var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"node-transition"},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"before-leave":_vm.leave,"leave":_vm.leave}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }